export default function (value, currency) {
	let fixed = currency == 'HUF' ? 0 : 2;
	value = parseFloat(value);
	if (typeof value != 'undefined' && value != null) {
		return new Intl.NumberFormat('hu', { minimumFractionDigits: fixed, maximumFractionDigits: fixed }).format(value);
	} else
		return '';
}
